import { Head, Link } from "@inertiajs/react";
import { z } from "zod";
import { formatDistanceToNow } from "date-fns";
import { SpreadsheetSchema } from "@/schemas";
import { Table, Button, Heading, Box, Text } from "@radix-ui/themes";

const PropsSchema = z.object({
  spreadsheets: z.array(SpreadsheetSchema),
});

type Props = z.infer<typeof PropsSchema>;

export default function DashboardShow(props: Props) {
  const { spreadsheets } = PropsSchema.parse(props);

  const formatDate = (dateString: string) => {
    return formatDistanceToNow(new Date(dateString), { addSuffix: true });
  };

  return (
    <>
      <Head title="Dashboard" />
      <Box>
        <Heading size="5" as="h1" mb="6">
          Your spreadsheets
        </Heading>

        {spreadsheets.length === 0 ? (
          <Text color="gray">
            No spreadsheets found. Create one in Google Drive to get started.
          </Text>
        ) : (
          <Table.Root>
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeaderCell>Title</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Modified</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Actions</Table.ColumnHeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {spreadsheets.map((spreadsheet) => (
                <Table.Row key={spreadsheet.id}>
                  <Table.Cell>{spreadsheet.name}</Table.Cell>
                  <Table.Cell>
                    {spreadsheet.modified_time
                      ? formatDate(spreadsheet.modified_time)
                      : "N/A"}
                  </Table.Cell>
                  <Table.Cell>
                    <Button variant="soft" size="1" asChild>
                      <Link href={`/sheets/${spreadsheet.id}`}>Open</Link>
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
        )}
      </Box>
    </>
  );
}
